'use client'

import {FC, useEffect} from 'react'

import {SignIn} from '@/components/user/auth/SignIn'
import {SignInBenefits} from '@/components/user/auth/SignInBenefits'
import {Layout} from '@/components/user-portal/layout/Layout'
import {analytics} from '@/utils/tracking/analytics'

const LoginPage: FC = () => {
  useEffect(() => {
    analytics.track('Login screen viewed')
  }, [])

  return (
    <Layout hasLogin={false}>
      <SignIn />
      <SignInBenefits />
    </Layout>
  )
}

export default LoginPage
